@if (messages$ | async; as messages) {
  <div class="udex-grid udex-mx-auto">
    @for (confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track confMsg; let i = $index) {
      <div animate.enter="fade-in" animate.leave="fade-out" class="global-message global-message-success udex-mt-32">
        <udex-message-strip design="Positive" status-type="Icon" hide-close-button>
          <span class="body--s">{{ confMsg | cxTranslate }}</span>
        </udex-message-strip>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div animate.enter="fade-in" animate.leave="fade-out" class="global-message global-message-info udex-mt-32">
        <udex-message-strip design="Information" status-type="Icon" hide-close-button>
          <span class="body--s">{{ infoMsg | cxTranslate }}</span>
        </udex-message-strip>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_WARNING]; track infoMsg; let i = $index) {
      <div animate.enter="fade-in" animate.leave="fade-out" class="global-message global-message-warning udex-mt-32">
        <udex-message-strip design="Warning" status-type="Icon" hide-close-button>
          <span class="body--s">{{ infoMsg | cxTranslate }}</span>
        </udex-message-strip>
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      <div animate.enter="fade-in" animate.leave="fade-out" class="global-message global-message-danger udex-mt-32">
        <udex-message-strip design="Negative" status-type="Icon" hide-close-button>
          <span class="body--s">{{ errorMsg | cxTranslate }}</span>
        </udex-message-strip>
      </div>
    }
  </div>
}
